import React from 'react';

import MediaEmbed from '../../../../shared/MediaEmbed/MediaEmbed';
import isWideAlignment from '../isWideAlignment/isWideAlignment';
import getDynamicClasses from '../getDynamicClasses/getDynamicClasses';
import getDynamicCarouselMediaClasses from '../getDynamicCarouselMediaClasses/getDynamicCarouselMediaClasses';
import getDynamicTitleClasses from '../getDynamicTitleClasses/getDynamicTitleClasses';

const prepareSlideMarkup = (slides = [], props = {}, isMobileScreen = false) => {
    if (!slides || slides.length < 1) return null;

    const { data = {} } = props;

    const { removeBottomPadding, removeTopPadding } = data || {};

    return slides.map((slide = {}, i) => {
        const {
            alignment,
            title,
            subTitle,
            titleTextColor,
            subTitleTextColor,
            backgroundColor,
            backgroundImage,
            textColor,
        } = slide;

        const media = slide.media && slide.media.length > 0 ? slide.media[0] : {};

        const { type, src, poster, altText, youtubeSourceUrl, vimeoSourceUrl } = media;

        const mediaSources = media?.sources?.[0] || {};

        const vimeoId =
            mediaSources[Object.keys(mediaSources)[0]]
                ?.split('https://player.vimeo.com/external/')
                ?.pop()
                ?.split('.')[0] || null;

        const mediaEmbedProps = {
            mediaType: type,
            altText: altText,
            mediaSrc: src,
            mediaPoster: poster,
            mediaSources,
            vimeoId,
            youtubeSourceUrl: youtubeSourceUrl,
            vimeoSourceUrl: vimeoSourceUrl,
            parentProp: props,
        };

        const composedMedia = <MediaEmbed {...mediaEmbedProps} />;

        const headerStyle = {
            color: titleTextColor,
        };

        const subHeaderStyle = {
            color: subTitleTextColor,
        };

        const wrapperStyle = {
            backgroundColor,
            backgroundImage: backgroundImage ? `url('${backgroundImage}')` : null,
            color: textColor,
        };

        const titleMarkup = title && <h2 style={headerStyle} dangerouslySetInnerHTML={{ __html: title }} />;

        const subTitleMarkup = subTitle && <h3 style={subHeaderStyle} dangerouslySetInnerHTML={{ __html: subTitle }} />;

        const isWideMedia = isWideAlignment(alignment);
        const dynamicClasses = getDynamicClasses(alignment, removeBottomPadding, removeTopPadding, src);
        const dynamicCarouselMediaClasses = getDynamicCarouselMediaClasses(isWideMedia);
        const dynamicTitleClasses = getDynamicTitleClasses(isWideMedia);

        function renderMobileView() {
            return (
                <div key={i}>
                    <div className={dynamicClasses} style={wrapperStyle}>
                        <div className="col-md-12 text-center text-wrapper">
                            {titleMarkup}
                            {subTitleMarkup}
                        </div>
                        <div className="col-md-12 image-wrapper">{composedMedia}</div>
                    </div>
                </div>
            );
        }

        function renderSideBySideView(media) {
            return (
                <div key={i}>
                    <div className={dynamicClasses} style={wrapperStyle}>
                        <div className="row">
                            {alignment === 'left' && (
                                <div className={dynamicTitleClasses}>
                                    {titleMarkup}
                                    {subTitleMarkup}
                                </div>
                            )}
                            <div className={dynamicCarouselMediaClasses}>{media}</div>
                            {alignment === 'right' && (
                                <div className={dynamicTitleClasses}>
                                    {titleMarkup}
                                    {subTitleMarkup}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        function renderCenteredView(media) {
            return (
                <div key={i}>
                    <div className={dynamicClasses} style={wrapperStyle}>
                        <div className="row">
                            {alignment === 'text-top-image-bottom' && (
                                <div className={dynamicTitleClasses}>
                                    {titleMarkup}
                                    {subTitleMarkup}
                                </div>
                            )}
                            <div className={dynamicCarouselMediaClasses}>{media}</div>
                            {alignment === 'text-bottom-image-top' && (
                                <div className={dynamicTitleClasses}>
                                    {titleMarkup}
                                    {subTitleMarkup}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        function renderDefaultView() {
            return (
                <div key={i}>
                    <div className={dynamicClasses} style={wrapperStyle}>
                        <div className="row">
                            <div className="col-md-6 text-wrapper">
                                {titleMarkup}
                                {subTitleMarkup}
                            </div>
                            <div className="col-md-6 image-wrapper">{composedMedia}</div>
                        </div>
                    </div>
                </div>
            );
        }

        const renderCarousel = () => {
            if (isMobileScreen) {
                return renderMobileView();
            } else {
                switch (alignment) {
                    case 'left':
                    case 'right':
                        return renderSideBySideView(composedMedia);
                    case 'text-top-image-bottom':
                    case 'text-bottom-image-top':
                    case 'center':
                        return renderCenteredView(composedMedia);
                    default:
                        return renderDefaultView();
                }
            }
        };

        return renderCarousel();
    });
};

export default prepareSlideMarkup;
